import {
  GET_LOTS_DATA_RES,
  GET_LOTS_DATA_REQ,
  GET_LOTS_DATA_ERR,

  CLEAR_LOTS_DATA,
} from '../../actions'

const usersInitialState = {
  error: null,
  loading: false,
  loaded: false,
  data: null
}

const lots = ( state = usersInitialState, action) => {
  switch( action.type ){
    case GET_LOTS_DATA_REQ:
      return {
        ...state,
        loading: true,
      }
    case GET_LOTS_DATA_RES:
      return {
        ...state,
        data: action.payload,
        loaded: true,
        loading: false
      }
    case GET_LOTS_DATA_ERR:
      return {
        ...state,
        error: action.payload
      }
    case CLEAR_LOTS_DATA:
      return {
        state
      }
      default:
        return state
  }
}

export default lots